import clsx from "clsx";
import Icon from "assets/img/icon.svg";
import HeroMark from "assets/img/home/hero-mark.svg";
import { RouteList } from "Routes";
import { NavLink } from "react-router-dom";
import { Fragment, useContext } from "react";
import { GlobalContext } from "contexts/GlobalContext";
import { ReactComponent as SiteName } from "assets/img/site-name.svg";
import { Constants } from "utils/Constants";

export const Navbar = (props: { className?: string }) => {
    const { className } = props;
    const { isAuthenticated, userData, globalData } = useContext(GlobalContext);

    return (
        <nav className={clsx("navbar text-bg-dark navbar-expand-lg sticky-top", className)}>
            <div className="container flex-row">
                <NavLink className="navbar-brand d-flex align-items-center" to={RouteList.Home} exact={true}>
                    <img
                        alt="Frankenstories"
                        className="navbar-brand__icon me-2"
                        src={Icon}
                        style={{ height: 26, maxWidth: "100%" }}
                    />

                    <span className="navbar-brand__wordmark me-2">
                        <SiteName className="navbar-brand__name svg-link" />
                        <img src={HeroMark} alt="" className="navbar-brand__mark" />
                    </span>
                </NavLink>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbar"
                    aria-label="Toggle navbar"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbar">
                    <ul className="navbar-nav gap-lg-2 me-auto ms-lg-3">
                        <li className="nav-item">
                            <NavLink className="nav-link" to={RouteList.MyGames}>
                                <span className="nav-link__icon fal fa-fw fa-gamepad"></span>
                                <span className="nav-link__text">My games</span>
                            </NavLink>
                        </li>

                        {!userData?.isStudent && (
                            <li className="nav-item">
                                <NavLink className="nav-link" to={RouteList.Discover}>
                                    <span className="nav-link__icon fal fa-fw fa-compass"></span>
                                    <span className="nav-link__text">Discover</span>
                                </NavLink>
                            </li>
                        )}

                        <li className="nav-item">
                            <NavLink className="nav-link" to={RouteList.HallOfFame}>
                                <span className="nav-link__icon fal fa-fw fa-trophy"></span>
                                <span className="nav-link__text">Hall of Fame</span>
                            </NavLink>
                        </li>

                        {!userData?.isStudent && (
                            <li className="nav-item dropdown">
                                <button className="nav-link" data-bs-toggle="dropdown">
                                    <span className="nav-link__icon fal fa-fw fa-chalkboard-teacher"></span>
                                    <span className="nav-link__text">For teachers</span>
                                </button>

                                <ul className="dropdown-menu">
                                    <li>
                                        <NavLink
                                            className="dropdown-item"
                                            to="/transforming-student-writing-with-Frankenstories"
                                        >
                                            How it works
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/reviews" className="dropdown-item">
                                            Reviews
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="dropdown-item"
                                            to={Constants.purchasingInfoForSchoolsAndDistricts}
                                        >
                                            Schools & districts
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="dropdown-item" to={RouteList.Pricing}>
                                            Pricing
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                        )}
                    </ul>

                    <ul className="navbar-nav gap-lg-2">
                        {isAuthenticated ? (
                            <Fragment>
                                <li>
                                    <NavLink className="nav-link" to={RouteList.Classes}>
                                        <span className="nav-link__icon fal fa-fw fa-users"></span>
                                        <span className="nav-link__text">Classes</span>
                                    </NavLink>
                                </li>

                                <li className="nav-item position-relative">
                                    <NavLink to={RouteList.Profile} className="nav-link">
                                        <span className="nav-link__icon fal fa-fw fa-user"></span>
                                        <span className="nav-link__text">Profile</span>
                                    </NavLink>

                                    {isAuthenticated && !userData?.isStudent && globalData?.isSubscribed === false && (
                                        <span
                                            title="Expired subscription"
                                            className="z-1 position-absolute top-100 start-50 translate-middle badge rounded-pill bg-danger"
                                        >
                                            &nbsp;
                                        </span>
                                    )}
                                </li>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <li className="nav-item dropdown" id="nav-register">
                                    <NavLink
                                        to={RouteList.Signup}
                                        className="nav-link"
                                        onClick={() => {
                                            // if the current matches the signup route then reload the page
                                            window.location.pathname === RouteList.Signup && window.location.reload();
                                        }}
                                    >
                                        <span className="nav-link__icon fal fa-fw fa-user-plus"></span>
                                        <span className="nav-link__text">Sign up</span>
                                    </NavLink>
                                </li>

                                <li className="nav-item">
                                    <NavLink
                                        to={RouteList.Login}
                                        className="nav-link"
                                        onClick={() => {
                                            // if the current matches the login route then reload the page
                                            window.location.pathname === RouteList.Login && window.location.reload();
                                        }}
                                    >
                                        <span className="nav-link__icon fal fa-fw fa-right-to-bracket"></span>
                                        <span className="nav-link__text">Log in</span>
                                    </NavLink>
                                </li>
                            </Fragment>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};
